import { render, staticRenderFns } from "./StockInventorySurplusMobile.vue?vue&type=template&id=f4ad9aec&"
import script from "./StockInventorySurplusMobile.vue?vue&type=script&lang=js&"
export * from "./StockInventorySurplusMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
